import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import InterviewsApi from 'libs/api/interviews';
import Helpers from '../../../../../helpers';
import UIHelper from '../../../../../helpers/UIHelper';
import { Col, Row } from 'antd';
import { Button } from '../../../../../components';
import { EyeOutlined } from '@ant-design/icons';

const api = new InterviewsApi();

const useListCompany = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [listCompany, setListCompany] = useState([]);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const { t } = useTranslation();

  const columnsListCompany = useMemo(() => {
    return [
      {
        title: t('Titolo'),
        dataIndex: 'name',
        sorter: () => {},
      },
      {
        title: t('Utente'),
        dataIndex: 'user',
        render: (data) => data?.short_name || '',
      },
      {
        title: '',
        dataIndex: 'id',
        align: 'right',
        width: 150,
        fixed: 'right',
        render: (data, row) => (
          <Row
            gutter={[16, 16]}
            justify={'left'}
            onClick={(e) => e.stopPropagation()}
          >
            {row.can_link_to_interviews && (
              <Col>
                <Link to={`/interviews/interviews/answers/${id}/${row.id}/new`}>
                  <Button icon={<EyeOutlined />}>{t('Apri')}</Button>
                </Link>
              </Col>
            )}
          </Row>
        ),
      },
    ];
  }, [t, pathname, id]);

  useEffect(() => {
    (async () => {
      if (id) {
        setLoading(true);
        const searchParamsObj = Object.fromEntries([...searchParams]);
        try {
          const {
            data: { companies },
          } = await api.get(`${id}/list_company`, {
            params: { per: 10000, ...searchParamsObj },
          });
          setListCompany(companies);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      }
    })();
  }, [id, searchParams]);

  const handleDownloadExcelSingle = async () => {
    setLoading(true);
    try {
      const response = await api.getExcelSingle(id);
      Helpers.downloadFile(response, 'file.xlsx');
    } catch (e) {
      const error = e?.response?.data?.errors || [t('Something went wrong!')];
      UIHelper.openNotificationWithIcon('error', error.join('\n'));
    } finally {
      setLoading(false);
    }
  };

  const filters = useMemo(
    () => [
      {
        title: t('Votato'),
        type: 'select',
        name: 'filter_companies',
        values: [
          {
            title: 'Si',
            value: 1,
          },
          {
            title: 'No',
            value: 0,
          },
        ],
      },
    ],
    [t],
  );

  return {
    listCompany,
    columnsListCompany,
    handleDownloadExcelSingle,
    loading,
    filters,
  };
};

export default useListCompany;
